import React from 'react';
import { Checkbox, Form } from 'antd';
import { flatten } from 'lodash';
import styled from 'styled-components';

import { clearFieldErrors, handleFormErrors } from '../../common/errorHelpers';
import { getFormFieldData } from '../../common/filterHelpers';
import { SearchFormFieldEnum } from '../../common/searchFormField.types';
import { ContractTypeEnum } from '../../common/types';
import { mapErrorFieldsToFormLabels } from '../../components/CandidateDataForm';
import { FormCheckboxGroup } from '../../components/forms/FormCheckboxGroup';
import { FormInput } from '../../components/forms/FormInput';
import { FormLinkInput } from '../../components/forms/FormLinkInput';
import { FormTextArea } from '../../components/forms/FormTextArea';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import { useUpdateCandidate } from '../candidate-details/useUpdateCandidate';
import { CandidateType } from '../candidates/Candidates.types';
import { SaveButtonIcon } from '../dictionaries/DictionaryItemsList';

import { SubmitButton } from './RecruitmentDataForm';

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner,
  .ant-checkbox-input {
    transform: scale(1.4);
    margin-right: 10px;
  }
`;

type CandidateDescriptionProps = {
  candidate: CandidateType;
};

export const CandidateDescription: React.FC<CandidateDescriptionProps> = ({ candidate }) => {
  const [form] = Form.useForm();
  const updateCandidate = useUpdateCandidate();

  const contractTypesOptions = Object.values(ContractTypeEnum);

  const initialValues = {
    ...candidate,
    contractTypes: getFormFieldData(SearchFormFieldEnum.ContractTypes).toFormValueFormatter?.(
      flatten([candidate.contractTypes]) as string[]
    ),
  };

  const handleSubmit = () => {
    const dataValues = form.getFieldsValue();

    const formValuesToPayload = {
      ...dataValues,
      [SearchFormFieldEnum.ContractTypes]:
        getFormFieldData(SearchFormFieldEnum.ContractTypes).toPayloadValueFormatter?.(
          dataValues[SearchFormFieldEnum.ContractTypes]
        ) ?? [],
    };

    updateCandidate.mutate(
      { queryParams: { id: candidate?.uuid ?? '' }, data: formValuesToPayload },
      {
        onSuccess: () => clearFieldErrors(form),
        onError: (error) => {
          handleFormErrors({ error, form, mapErrorFieldsToFormLabels });
        },
      }
    );
  };

  return (
    <Form form={form} initialValues={initialValues} style={{ flexGrow: '1' }} layout="vertical" colon={false}>
      <StyledColumn gap="1rem">
        <FormLinkInput name="linkedinProfile" label="LinkedIn" />

        <FormInput name="workMode" label="Work mode" />

        <FormCheckboxGroup name="contractTypes" label="Supported contract" options={contractTypesOptions} vertical />

        <FormTextArea rows={4} name="expectedSalary" label="Salary description" />

        <FormTextArea rows={4} name="totalEmploymentCost" label="Total emplyment cost" />

        <StyledRow justifyContent="flex-end" marginTop="14px">
          <SubmitButton onClick={handleSubmit} icon={<SaveButtonIcon />}>
            Save
          </SubmitButton>
        </StyledRow>
      </StyledColumn>
    </Form>
  );
};
